<template>
  <card
    style="height: 100%;"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div v-if="teles.length === 1" class="device-picker">
      {{ teles[0].name }}
    </div>

    <warning
      :height="Math.floor(height / 3)"
      :loading="loading"
      :data="warning"
    ></warning>

    <div class="card-item">
      <div class="subtitle">
        虫害种类比例及变化趋势
      </div>

      <echart
        chart-id="tele"
        :options="options"
        :height="Math.floor((height / 3) * 2) - 62"
        :not-merge="true"
        @update-axis-pointer="updatePieValue"
      ></echart>
    </div>
  </card>
</template>

<script>
import mixin from '../mixin'
import Card from '../card'
import Warning from './warning'
import Echart from '@/components/Chart'
// import Proportion from './proportion'
// import Trend from './trend'
import { getWarnings } from '@/service/telemetry'
import sleep from '@/utlis/sleep'

export default {
  mixins: [mixin],
  components: { Card, Warning, Echart },
  props: { devKey: String },
  data() {
    return {
      loading: false,
      pointer: null,
      warnings: [],
      trends: [],
      deviceData: []
    }
  },
  computed: {
    warning() {
      return this.warnings.filter(o => o.deviceId === this.deviceId)
    },
    deviceId() {
      if (this.devKey) {
        const dev = this.teles.find(t => t.key === this.devKey)
        return dev.id
      } else {
        return ''
      }
    },
    options() {
      let row = this.trends[0] ? this.trends[0].data : []
      let head = ['category'].concat(row.map(r => r.date))
      let source = this.trends
        .map(t =>
          [t.category].concat(
            t.data.map(d => {
              let device = d.devices.find(dev => dev.id === this.deviceId)
              return device ? device.qty : 0
            })
          )
        )
        .filter(o => o.slice(1).some(i => i > 0))
      if (!(source && source[0])) {
        source = [head.map((_, index) => (index === 0 ? '暂无识别' : 0))]
      }
      return {
        legend: {
          left: 20,
          right: '6%',
          bottom: 16,
          type: 'scroll',
          pageButtonPosition: 'end',
          pageIconSize: 16,
          textStyle: { color: '#9aa8d4' },
          pageTextStyle: { color: '#dcdfe6', fontSize: 14 }
        },
        tooltip: {
          trigger: 'axis',
          confine: false,
          appendToBody: false
        },
        dataset: {
          source: [head].concat(source)
        },
        xAxis: { type: 'category' },
        yAxis: { gridIndex: 0, splitLine: { show: false } },
        grid: { top: '52%', bottom: 54, right: 20 },
        series: source
          .map(() => ({
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            stack: 'cate'
          }))
          .concat([
            {
              type: 'pie',
              radius: ['25%', '40%'],
              center: ['50%', '25%'],
              stillShowZeroSum: true,
              labelLine: { show: true },
              encode: {
                itemName: 'category',
                value: this.pointer || head[1],
                tooltip: this.pointer || head[1]
              },
              tooltip: {
                trigger: 'item',
                backgroundColor: 'rgba(39, 102, 171, .6)',
                padding: [6, 10, 9, 10],
                textStyle: {
                  fontWeight: 'bold',
                  fontFamily: 'Microsoft YaHei',
                  fontSize: 14,
                  height: 22
                }
              }
            }
          ])
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true

      const [{ data }] = await Promise.all([
        getWarnings(this.companyId),
        sleep(1)
      ])
      // this.warnings = data.warnings
      this.trends = data.trends
      this.warnings = data.warnings.map(w => {
        let summary = 0
        const t = data.trends.find(t => t.id === w.categoryId)

        if (t) {
          summary = t.data.reduce((total, cur) => {
            const dev = cur.devices.find(dev => dev.id === this.deviceId)
            return dev ? total + dev.qty : total
          }, 0)
        }

        return { ...w, summary }
      })

      this.loading = false
    },
    updatePieValue(evt) {
      let xAxisInfo = evt.axesInfo[0]
      if (xAxisInfo) {
        this.pointer = Math.round(xAxisInfo.value + 1)
      }
    }
  }
}
</script>

<style lang="css" scoped></style>
